import React from "react";
import { FaUpload } from "react-icons/fa";
import PropTypes from "prop-types";

const New = ({ handleAddNew }) => {
    return (
        <button
            onClick={handleAddNew}
            className="flex items-center gap-2 bg-blue-600 text-white hover:text-gray-900 border border-gray-200 hover:border-indigo-300 hover:bg-indigo-50 text-gray-700 px-5 py-3 rounded-xl transition shadow-sm"
        >
            <FaUpload
                size={18}
                className="
                    transition-all duration-300
                    group-hover:text-yellow-300
                    group-hover:rotate-6
                "
            />

            <span className="tracking-wide">
                Add New Task
            </span>
        </button>
    );
};

New.propTypes = {
    handleAddNew: PropTypes.func.isRequired,
};

export default New;